import { render, staticRenderFns } from "./WarningOutline.vue?vue&type=template&id=887a00f0&"
import script from "./WarningOutline.vue?vue&type=script&lang=ts&"
export * from "./WarningOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports